module.exports = __webpack_public_path__ + "img/map-menu-2@2x.f6344957.png";